import { InjectionToken } from '@angular/core';
import { IConfig } from 'unleash-proxy-client';

export type UnleashConfig = IConfig;

export const UNLEASH_CONFIG = new InjectionToken<UnleashConfig>('UnleashConfig');
